import { defineWorkflow } from './workflow-builder'

/**
 * WF-FG-01 (Inbound FG Auto-Labeler Batch) — `docs/tl-doc/12B-SERVICE-DATA/JAL_12B-SERVICE-DATA-WF-FG-01.md` §1–§8 [C].
 * Penyimpangan (laporan 12):
 * - [R] status awal `FG_IN_PRODUCTION` ("Dalam Produksi", data ALM belum lengkap) + `ACT_FG_FEED_RECV` — prototype v7.40
 *   punya status itu; TL WFL flowchart memakai FG_FEED → ACT_FG_FEED_RECV.
 * - [R] Kadiv bisa Setujui/Tahan/Kembalikan (`ACT_FG_DISPOSISI_APP`, `ACT_FG_KADIV_HOLD`, `ACT_FG_KADIV_REJ`) setelah
 *   disposisi 2 jam — BA IFG-01 §Rules; TL hanya mendaftarkan Approve untuk Kadiv.
 * - Persetujuan otomatis 8 jam (`ACT_FG_AUTO_APP`) dijalankan handler `sla-sweep` (tanpa worker SLA di local mode).
 */
export const WF_FG = defineWorkflow({
  no: 9,
  code: 'WF-FG-01',
  name: 'Inbound FG Auto-Labeler Batch Workflow',
  entity: 'fg_labeler_batch',
  statuses: [
    ['FG_IN_PRODUCTION', 'Dalam Produksi', true, false, '#F59E0B', 'Menunggu data ALM — batch belum bisa dicek'],
    ['FG_READY_HANDOVER', 'Ready for Handover', false, false, '#64748B', 'Batch diterima dari Auto-Labeler API'],
    ['FG_PENDING_APP', 'Menunggu Approval', false, false, '#F59E0B', 'Admin FG telah cek & ajukan ke Supervisor'],
    ['FG_APPROVED', 'Disetujui', false, false, '#10B981', 'Batch disetujui, siap diterbitkan tugas putaway'],
    ['FG_HELD', 'Held', false, false, '#F97316', 'Batch ditahan untuk verifikasi fisik tambahan'],
    ['FG_RETURN_PROD', 'Returned to Production', false, true, '#EF4444', 'Batch ditolak & dikembalikan ke Produksi'],
    ['FG_ASSIGNED', 'Assigned', false, false, '#06B6D4', 'Tugas putaway per operator telah dibagikan'],
    ['FG_PUTAWAY_COMPLETED', 'Putaway Completed', false, true, '#059669', 'Semua unit batch telah masuk rak']
  ],
  actors: [
    ['ACT_FG_ADMIN_FG', 'Admin WH FG', 'admin_wh_fg', null],
    ['ACT_FG_SPV_FG', 'Supervisor WH FG', 'supervisor_wh_fg', null],
    ['ACT_FG_KADIV_FG', 'Kadiv WH FG', 'kadiv_wh_fg', null],
    ['ACT_FG_OP_FG', 'Operator WH FG', 'operator_wh_fg', null]
  ],
  components: [
    ['CMP_FG_FEED', 'Tombol Terima Data ALM', 'ACTION', {}],
    ['CMP_FG_SUBMIT_APP', 'Tombol Terima & Ajukan', 'ACTION', { color: '#3B82F6', variant: 'primary' }],
    ['CMP_FG_APPROVE', 'Tombol Approve Batch', 'ACTION', {}],
    ['CMP_FG_HOLD', 'Tombol Hold Batch', 'ACTION', {}],
    ['CMP_FG_RETURN', 'Tombol Return to Production', 'ACTION', {}],
    ['CMP_FG_HELD_APPROVE', 'Tombol Approve Batch Held', 'ACTION', {}],
    ['CMP_FG_HELD_RETURN', 'Tombol Return to Production dari Held', 'ACTION', {}],
    ['CMP_FG_DISPOSISI', 'Tombol Disposisi Kadiv', 'ACTION', {}],
    ['CMP_FG_AUTO_APPROVE', 'Aksi Auto-Approve 8 Jam', 'ACTION', {}],
    ['CMP_FG_ASSIGN_PUT', 'Tombol Bagi Tugas Putaway', 'ACTION', {}],
    ['CMP_FG_FINISH_PUT', 'Tombol Selesai Putaway', 'ACTION', {}],
    ['CMP_FG_PANEL_HEADER', 'Panel Header Batch Inbound', 'PANEL', {}],
    ['CMP_FG_PANEL_ITEMS', 'Panel Karton & Barcode QR', 'PANEL', {}],
    ['CMP_FG_PANEL_TASKS', 'Panel Tugas Putaway (FPW)', 'PANEL', {}]
  ],
  actions: [
    ['ACT_FG_FEED_RECV', 'FG_IN_PRODUCTION', 'FG_READY_HANDOVER', 'CMP_FG_FEED', false, false, null],
    ['ACT_FG_SUBMIT', 'FG_READY_HANDOVER', 'FG_PENDING_APP', 'CMP_FG_SUBMIT_APP', false, false, null],
    ['ACT_FG_SPV_APPROVE', 'FG_PENDING_APP', 'FG_APPROVED', 'CMP_FG_APPROVE', false, false, null],
    ['ACT_FG_SPV_HOLD', 'FG_PENDING_APP', 'FG_HELD', 'CMP_FG_HOLD', true, true, null],
    ['ACT_FG_SPV_REJ', 'FG_PENDING_APP', 'FG_RETURN_PROD', 'CMP_FG_RETURN', true, true, null],
    ['ACT_FG_HELD_APP', 'FG_HELD', 'FG_APPROVED', 'CMP_FG_HELD_APPROVE', false, false, null],
    ['ACT_FG_HELD_REJ', 'FG_HELD', 'FG_RETURN_PROD', 'CMP_FG_HELD_RETURN', true, true, null],
    ['ACT_FG_DISPOSISI_APP', 'FG_PENDING_APP', 'FG_APPROVED', 'CMP_FG_DISPOSISI', true, true, null],
    ['ACT_FG_KADIV_HOLD', 'FG_PENDING_APP', 'FG_HELD', 'CMP_FG_HOLD', true, true, null],
    ['ACT_FG_KADIV_REJ', 'FG_PENDING_APP', 'FG_RETURN_PROD', 'CMP_FG_RETURN', true, true, null],
    ['ACT_FG_AUTO_APP', 'FG_PENDING_APP', 'FG_APPROVED', 'CMP_FG_AUTO_APPROVE', false, false, null],
    ['ACT_FG_ASSIGN', 'FG_APPROVED', 'FG_ASSIGNED', 'CMP_FG_ASSIGN_PUT', false, false, null],
    [
      'ACT_FG_COMPLETE',
      'FG_ASSIGNED',
      'FG_PUTAWAY_COMPLETED',
      'CMP_FG_FINISH_PUT',
      false,
      false,
      { is_stored: true, stored_at: '$NOW' }
    ]
  ],
  eligibility: [
    ['ACT_FG_FEED_RECV', 'ACT_FG_ADMIN_FG'],
    ['ACT_FG_SUBMIT', 'ACT_FG_ADMIN_FG'],
    ['ACT_FG_SPV_APPROVE', 'ACT_FG_SPV_FG'],
    ['ACT_FG_SPV_HOLD', 'ACT_FG_SPV_FG'],
    ['ACT_FG_SPV_REJ', 'ACT_FG_SPV_FG'],
    ['ACT_FG_HELD_APP', 'ACT_FG_SPV_FG'],
    ['ACT_FG_HELD_REJ', 'ACT_FG_SPV_FG'],
    ['ACT_FG_DISPOSISI_APP', 'ACT_FG_KADIV_FG'],
    ['ACT_FG_KADIV_HOLD', 'ACT_FG_KADIV_FG'],
    ['ACT_FG_KADIV_REJ', 'ACT_FG_KADIV_FG'],
    ['ACT_FG_HELD_APP', 'ACT_FG_KADIV_FG'],
    ['ACT_FG_HELD_REJ', 'ACT_FG_KADIV_FG'],
    ['ACT_FG_ASSIGN', 'ACT_FG_ADMIN_FG'],
    ['ACT_FG_COMPLETE', 'ACT_FG_OP_FG']
  ],
  panels: [
    ['CMP_FG_PANEL_HEADER', 'FG_READY_HANDOVER', 'read', null],
    ['CMP_FG_PANEL_HEADER', 'FG_PENDING_APP', 'read', null],
    ['CMP_FG_PANEL_HEADER', 'FG_PUTAWAY_COMPLETED', 'read', null],
    ['CMP_FG_PANEL_ITEMS', 'FG_READY_HANDOVER', 'write', 'ACT_FG_ADMIN_FG'],
    ['CMP_FG_PANEL_ITEMS', 'FG_PENDING_APP', 'read', null],
    ['CMP_FG_PANEL_TASKS', 'FG_APPROVED', 'write', 'ACT_FG_ADMIN_FG'],
    ['CMP_FG_PANEL_TASKS', 'FG_ASSIGNED', 'read', null]
  ],
  emailStatuses: ['FG_PENDING_APP', 'FG_APPROVED', 'FG_HELD', 'FG_RETURN_PROD']
})

export type FgStatusCode = (typeof WF_FG.spec.statuses)[number][0]
export type FgActorCode = (typeof WF_FG.spec.actors)[number][0]
export type FgActionName = (typeof WF_FG.spec.actions)[number][0]
export const buildWorkflowFgSeed = WF_FG.build
